import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { ThemeProvider } from '@mui/material/styles'
import { RoleBadge } from './RoleBadge'

export const EmailsRecipientsTable = ({
  contacts,
  classes,
  selected,
  handleChange,
  theme,
}) => {
  return (
    <TableContainer
      style={{
        marginTop: '2em',
      }}
    >
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow
            sx={{
              fontSize: '0.875em',
              '& th': {
                fontSize: '0.875em',
              },
            }}
          >
            <TableCell
              className={classes.tableHeader}
              padding="checkbox"
            ></TableCell>
            <TableCell className={classes.tableHeader} align="left">
              Nom
            </TableCell>
            <TableCell className={classes.tableHeader} align="left">
              Prénom
            </TableCell>
            <TableCell className={classes.tableHeader} align="left">
              Copropriétaire
            </TableCell>
            <TableCell className={classes.tableHeader} align="left">
              Mail
            </TableCell>
            <TableCell className={classes.tableHeader} align="left">
              Rôle
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(contacts) &&
            contacts.map((item, key) => {
              return (
                <>
                  <TableRow
                    onClick={(event) => {
                      handleChange(item.email)
                    }}
                    key={item.email}
                    sx={{
                      '&:last-child td, &:last-child th': {
                        border: 0,
                      },
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <TableCell
                        className={classes.tableCell}
                        padding="checkbox"
                      >
                        <Checkbox
                          size="small"
                          id={`checkbox-${key}`}
                          name={item.email}
                          value={item.email}
                          checked={selected.includes(item.email)}
                          onChange={handleChange}
                          color="primary"
                        />
                      </TableCell>
                      <TableCell align="left">{item.lastName}</TableCell>
                      <TableCell align="left">{item.firstName}</TableCell>
                      <TableCell align="left">{item.coowner?.label}</TableCell>
                      <TableCell align="left">{item.email}</TableCell>

                      <TableCell align="left">
                        {item.roles?.map((role, index) => (
                          <RoleBadge role={role} key={index} />
                        ))}
                      </TableCell>
                    </ThemeProvider>
                  </TableRow>
                </>
              )
            })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
